import React, {Component} from 'react'
import {getCustomerCity, request} from "../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import DefaultModal from "../invoice/DefaultModal";
import {validateField} from "../../common/validation";
import moment from "moment/moment";
import {Col, Form, FormGroup, Input, Label} from "reactstrap";
import Datetime from "react-datetime";
import Select from "../../local_node_modules/react-select";
import TextEditor from "../../components/TextEditor"
import MultiSelectAnnouncement from "../../components/MultiSelectAnnouncement";
import {isValidAnnouncement} from "../../common/componentValidation";
import Alert from "react-s-alert";

class AnnouncementModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            data: {},
            processing: false,
            excludeDistributorsList: [],
            includeDistributorsList: [],
            includeCitiesList: [],
            cityList: []
        };
        this.save = this.save.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateField = this.validateField.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.viewOptionsList = this.viewOptionsList.bind(this);
        this.checkDateValidity = this.checkDateValidity.bind(this);
    }

    async componentDidMount() {
        let {mode, recordId} = this.props;
        await getCustomerCity().then((response) => {
            let cityList = [];
            response.data.map(m => {
                cityList.push({label: m, value: m});
            });
            this.setState({cityList})
        }).catch((err) => {
            showAxiosError(err);
        });

        if ((mode === "update") && recordId) {
            let self = this;
            let params = {
                url: "/announcement/fetchAnnouncementByRecordId",
                method: 'post',
                data: recordId
            };
            request(params).then(function (response) {
                self.setState({data: response.data}, () => self.viewOptionsList());

            }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            let announcementDetails = this.state.announcementDetails;
            this.setState({announcementDetails});
        }
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }


    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    handleInputChange(name, value) {
        let data = this.state.data;
        let includeDistributorsList = deepCopyObject(this.state.includeDistributorsList);
        let excludeDistributorsList = deepCopyObject(this.state.excludeDistributorsList);
        let includeCitiesList = deepCopyObject(this.state.includeCitiesList);
        if (name === "includeDistributors") {
            includeDistributorsList = value;
        }
        if (name === "excludeDistributors") {
            excludeDistributorsList = value;
        }
        if (name === "includeCitiesList") {
            includeCitiesList = value;
        }
        if (name === "showAll") {
            data["includeDistributors"] = "";
            data["excludeDistributors"] = "";
            data["includeCitiesList"] = "";
            excludeDistributorsList = [];
            includeDistributorsList = [];
            includeCitiesList = [];
        }
        data[name] = value;
        this.setState({data, excludeDistributorsList, includeDistributorsList, includeCitiesList});
    }

    onChangeDate = (momentObj, type, fieldValue) => {
        let value;
        if (!(typeof momentObj === "string")) {
            value = momentObj.format("YYYY-MM-DDTHH:mm:ss");
        } else {
            value = momentObj;
            if (type === "datetime" && moment(value, "DD-MM-YYYY", true).isValid()) {
                value = moment(value, "DD-MM-YYYY", true).format("YYYY-MM-DDTHH:mm:ss");
            }
        }
        let data = this.state.data;
        data[fieldValue] = value;
        this.setState({data});
    }

    checkDateValidity(current, name) {
        let data = deepCopyObject(this.state.data);
        let copyCurrent = current.clone();
        if (name === 'startTime') {
            return moment(copyCurrent).isValid;
        }
        if (name === 'finishTime') {
            return copyCurrent.isAfter(data.startTime);
        }
    }

    onCancel() {
        this.props.listener(false, false);
    }

    save(e) {
        e.preventDefault();
        let data = deepCopyObject(this.state.data);
        let self = this;
        let includeDistributorsList = deepCopyObject(this.state.includeDistributorsList);
        let excludeDistributorsList = deepCopyObject(this.state.excludeDistributorsList);
        let includeCitiesList = deepCopyObject(this.state.includeCitiesList);
        data.excludeDistributors = excludeDistributorsList;
        data.includeDistributors = includeDistributorsList;
        data.includeCitiesList = includeCitiesList;
        let excludeDistributors = "";
        let includeDistributors = "";
        let includeCities = "";
        if (data.excludeDistributors !== null && data.excludeDistributors !== undefined && data.excludeDistributors !== "") {
            data.excludeDistributors.map((id, index) => {
                excludeDistributors = excludeDistributors + (index + 1 === data.excludeDistributors.length ? id.value : id.value + ",")
            });
        }
        if (data.includeDistributors !== null && data.includeDistributors !== undefined && data.includeDistributors !== "") {
            data.includeDistributors.map((id, index) => {
                includeDistributors = includeDistributors + (index + 1 === data.includeDistributors.length ? id.value : id.value + ",")
            });
        }
        if (data.includeCitiesList !== null && data.includeCitiesList !== undefined && data.includeCitiesList !== "") {
            data.includeCitiesList.map((id, index) => {
                includeCities = includeCities + (index + 1 === data.includeCitiesList.length ? id.value : id.value + ",")
            });
        }
        data.excludeDistributors = excludeDistributors;
        data.includeDistributors = includeDistributors;
        data.includeCitiesList = includeCities;
        let result = isValidAnnouncement(data);
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            let params = {
                url: `/announcement/saveAnnouncementRequest`,
                method: `post`,
                data: data
            };
            self.setState({processing: true});
            request(params).then(response => {
                Alert.success(("Duyurunuz başarıyla kaydedilmiştir."), {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 3000
                });
                self.setState({data: response.data, error: {}}, () => this.props.toggleModal(false, true))
            }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            this.setState({error});
        }
    }


    viewOptionsList() {
        let data = deepCopyObject(this.state.data);
        let excludeDistributorsList = [];
        let includeDistributorsList = [];
        let includeCitiesList = [];
        if (this.props.mode === "update") {
            if (data !== null) {
                if (!!data.excludeDistributors) {
                    let excludeDistributors = data.excludeDistributors.split(',');
                    if (!!this.props.allDistributors) {
                        this.props.allDistributors.forEach((element, index) => {
                            for (let i = 0; i < excludeDistributors.length; i++) {
                                if (element.value === parseInt(excludeDistributors[i])) {
                                    excludeDistributorsList.push({value: element.value, label: element.label});
                                }
                            }
                        })
                    }
                }
                if (!!data.includeDistributors) {
                    let includeDistributors = data.includeDistributors.split(',');
                    if (!!this.props.allDistributors) {
                        this.props.allDistributors.forEach((element, index) => {
                            for (let i = 0; i < includeDistributors.length; i++) {
                                if (element.value === parseInt(includeDistributors[i])) {
                                    includeDistributorsList.push({value: element.value, label: element.label});
                                }
                            }
                        })
                    }
                }
                if (!!data.includeCitiesList) {
                    let includeCities = data.includeCitiesList.split(',');
                    if (!!this.state.includeCitiesList) {
                        this.state.cityList.forEach((element, index) => {
                            for (let i = 0; i < includeCities.length; i++) {
                                if (element.value === includeCities[i]) {
                                    includeCitiesList.push({value: element.value, label: element.label});
                                }
                            }
                        })
                    }
                }
            }
        }
        this.setState({excludeDistributorsList, includeDistributorsList, includeCitiesList})
    }


    render() {
        let data = this.state.data;
        return (
            <DefaultModal
                isOpen={this.props.modal}
                title={`Duyuru ${this.props.mode === "create" ? "Oluştur" : "Düzenle"} `}
                size="lg"
                modalBodyStyle={{padding: "0"}}
                confirmBtnText={"Kaydet"}
                cancelBtnText={"İptal"}
                onConfirm={(e) => this.save(e)}
                onCancel={this.onCancel}>
                <Form className="px-4">
                    <FormGroup row>
                        <Label sm={4}>Duyuru Adı</Label>
                        <Col sm={8} className={this.validateClass("name")}>
                            <Input type="text" name="name" id="name" value={data && data.name ? data.name : ''}
                                   onChange={(e) => this.handleInputChange("name", e.target.value)}
                                   onBlur={(e) => this.validateField(e)}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Duyuru Türü</Label>
                        <Col sm={8} className={this.validateClass("type")}>
                            <Select
                                id="type"
                                clearable={false}
                                className="select-control"
                                name="type"
                                value={data && data.type ? data.type : ''}
                                placeholder="Seçiniz..."
                                onChange={(e) => e && this.handleInputChange("type", e.value)}
                                options={[{value: "CARD", label: "Kart"},
                                    {value: "MODAL", label: "Modal"}]}
                                onBlur={(e) => this.validateField(e)}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Tekrar Sayısı</Label>
                        <Col sm={8} className={this.validateClass("showCount")}>
                            <Input type="numericText" name="showCount"
                                   id="showCount"
                                   value={data && data.showCount ? data.showCount : ''}
                                   onChange={(e) => this.handleInputChange("showCount", e.target.value)}
                                   onBlur={(e) => this.validateField(e)}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Başlangıç Tarihi</Label>
                        <Col sm={8} className={this.validateClass("startTime")}>
                            <Datetime locale="tr"
                                      className="datepicker"
                                      input={true}
                                      closeOnSelect={true}
                                      inputProps={{id: 'startTime'}}
                                      onBlur={(momentObj) => this.validateField({
                                          target: {
                                              id: "startTime",
                                              dataset: {'vdata': "datetime"},
                                              value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
                                          }
                                      })}
                                      value={moment(data.startTime, "YYYY-MM-DDTHH:mm:ss", true).isValid() || moment(data.startTime, "YYYY-MM-DD HH:mm:ss", true).isValid() ?
                                          moment(data.startTime).format("DD-MM-YYYY HH:mm:ss") :
                                          data.startTime}
                                      isValidDate={(current) => this.checkDateValidity(current, 'startTime')}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm:ss"
                                      onChange={(e) => this.onChangeDate(e, "date", "startTime")}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Bitiş Tarihi</Label>
                        <Col sm={8} className={this.validateClass("finishTime")}>
                            <Datetime locale="tr"
                                      className="datepicker"
                                      inputProps={{id: 'finishTime'}}
                                      onBlur={(momentObj) => this.validateField({
                                          target: {
                                              id: "finishTime",
                                              dataset: {'vdata': "datetime"},
                                              value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
                                          }
                                      })}
                                      input={true}
                                      closeOnSelect={true}
                                      value={moment(data.finishTime, "YYYY-MM-DDTHH:mm:ss", true).isValid() || moment(data.finishTime, "YYYY-MM-DD HH:mm:ss", true).isValid() ?
                                          moment(data.finishTime).format("DD-MM-YYYY HH:mm:ss") :
                                          data.finishTime}
                                      isValidDate={(current) => this.checkDateValidity(current, 'finishTime')}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm:ss"
                                      onChange={(e) => this.onChangeDate(e, "date", "finishTime")}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Duyuru İçeriği</Label>
                        <Col sm={8} className={this.validateClass("content")}>
                            <TextEditor
                                name="content"
                                mode={this.props.mode}
                                listener={this.handleInputChange}
                                content={this.state.data}
                                onBlur={this.validateField}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{textAlign: 'center'}}>
                        <Label sm={12} style={{fontWeight: 'bold', fontSize: '16px'}}>İZİNLER</Label>
                    </FormGroup>
                    {!data.showAll &&
                        <FormGroup row>
                            <Label sm={4}>Gözükecek Bayiler</Label>
                            <Col sm={8}>
                                <MultiSelectAnnouncement
                                    mode={this.props.mode}
                                    listener={this.handleInputChange}
                                    name={"includeDistributors"}
                                    content={this.state.includeDistributorsList}
                                    includeDistributorsList={this.state.includeDistributorsList}
                                    options={this.props.allDistributors}
                                />
                            </Col>
                        </FormGroup>
                    }
                    {!data.showAll &&
                        <FormGroup row>
                            <Label sm={4}>Gözükmeyecek Bayiler</Label>
                            <Col sm={8}>
                                <MultiSelectAnnouncement
                                    mode={this.props.mode}
                                    listener={this.handleInputChange}
                                    name={"excludeDistributors"}
                                    excludeDistributorsList={this.state.excludeDistributorsList}
                                    content={this.state.excludeDistributorsList}
                                    options={this.props.allDistributors}
                                />
                            </Col>
                        </FormGroup>
                    }
                    {!data.showAll && this.state.cityList && this.state.cityList.length > 0 &&
                        <FormGroup row>
                            <Label sm={4}>Gözükecek İller</Label>
                            <Col sm={8}>
                                <MultiSelectAnnouncement
                                    listener={this.handleInputChange}
                                    name={"includeCitiesList"}
                                    onChange={(e) => e && this.handleInputChange("type", e.value)}
                                    content={this.state.includeCitiesList}
                                    options={this.state.cityList}
                                />
                            </Col>
                        </FormGroup>
                    }

                    {(!data.excludeDistributors && !data.includeDistributors) &&
                        <FormGroup row>
                            <Label sm={4}>Tüm Müşterilerde Gözüksün</Label>
                            <Col sm={8}>
                                <input type="checkbox" name="showAll"
                                       value={data.showAll}
                                       checked={data.showAll}
                                       onChange={e => this.handleInputChange("showAll", e.target.checked)}/>
                            </Col>
                        </FormGroup>
                    }
                </Form>
            </DefaultModal>
        )
    }
}

export default AnnouncementModal;